/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AwardStatusType = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
export type OverviewAwards_viewer = {
    readonly designAwardsQuery?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly name: string | null;
        readonly status: AwardStatusType | null;
    } | null> | null;
    readonly " $refType": "OverviewAwards_viewer";
};
export type OverviewAwards_viewer$data = OverviewAwards_viewer;
export type OverviewAwards_viewer$key = {
    readonly " $data"?: OverviewAwards_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewAwards_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewAwards_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isEditMode",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "designAwardsQuery",
          "storageKey": null,
          "args": null,
          "concreteType": "AwardType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'dc0a2aabeaf6726864e10aca1d4a3557';
export default node;
